import { render, staticRenderFns } from "./casegrid.vue?vue&type=template&id=1343bd00&scoped=true&"
import script from "./casegrid.vue?vue&type=script&lang=js&"
export * from "./casegrid.vue?vue&type=script&lang=js&"
import style0 from "./casegrid.vue?vue&type=style&index=0&id=1343bd00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1343bd00",
  null
  
)

export default component.exports